export default __webpack_public_path__ + "static/media/discounts-drinks-image.712e153b.svg";